
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favourites",
      function () {
        return require("private-next-pages/favourites.js");
      }
    ]);
  